// client/src/lib/socket.js
import { io } from "socket.io-client";

const FALLBACK_API_ORIGIN = "https://streamsite-v8dd.onrender.com";

const API_ORIGIN = (process.env.REACT_APP_API_URL || FALLBACK_API_ORIGIN).replace(/\/$/, "");
const CHAT_URL = (process.env.REACT_APP_CHAT_URL || API_ORIGIN).replace(/\/$/, "");

const socket = io(CHAT_URL, {
  autoConnect: false,
  path: "/socket.io",
  // Prefer a direct WebSocket connection so normal GAStreaming traffic does not
  // bounce through Engine.IO's cross-origin XHR polling handshake. The Render
  // Socket.IO server already explicitly allows gastreaming.live origins.
  transports: ["websocket"],
  upgrade: false,
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
});

export default socket;
